import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PlayBackPlayer } from './PlaybackPlayer';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import refresh from "packages/novous_web/src/assets/icons/Refresh.svg";
import upload from "packages/novous_web/src/assets/icons/upload-04.svg";

import download from "packages/novous_web/src/assets/icons/downlaodColor.svg";

import AlertToast from 'packages/novous_web/src/common/components/Alert';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

type PlaybackPlayerModalProps = {
  open: boolean;
  onClose: () => void;
  onRefresh: () => void;
  requestData: any
  cameraId?: any
  deviceId: string;
  verhicleId?: string
};

type RequestData = {
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  cameraType?: string;
};

type Segment = {
  startTime: string;
  endTime: string;
  status: 'AVAILABLE' | 'AVAILABLE_LOADED' | 'UNAVAILABLE';
};

type AlertItem = {
  startTime: string;
  endTime: string;
  status: string;
  cameraType?: string;
};

type AlertData = {
  data: {
    [key: string]: AlertItem[];
  };
};


export default function PlaybackPlayerModal({
  open,
  onClose,
  onRefresh,
  requestData,
  deviceId,
  verhicleId,
  cameraId
}: PlaybackPlayerModalProps) {
  console.log(requestData, 'requestData', cameraId);
  const [currentVideoData, setCurrentVideoData] = useState<any>(null);
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [cooldown, setCooldown] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  function formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    const hours = `${date.getHours()}`.padStart(2, "0");
    const minutes = `${date.getMinutes()}`.padStart(2, "0");
    const seconds = `${date.getSeconds()}`.padStart(2, "0");

    return `${year}-${month}-${day}:${hours}:${minutes}:${seconds}`;
  }

  const {
    data: footageVideoUploadData,
    error: footageVideoUploadError,
    loading: footageVideoUploadLoading,
    fetchData: fetchFootageVideoUploadData,
  } = useAxios<{ data: any, message: string }>(
    `${API_ENDPOINTS.sdCard.UPLOAD_FOOTAGE}`,
    "POST"
  );

  const {
    data: footageVideoDownloadData,
    error: footageVideoDownloadError,
    loading: footageVideoDownloadLoading,
    fetchData: fetchFootageVideoDownloadData,
  } = useAxios<{ data: any, message: string }>(
    `${API_ENDPOINTS.sdCard.DOWNLOAD_VIDEO}`,
    "POST"
  );

  useEffect(() => {
    if (footageVideoUploadData) {
      if (footageVideoUploadData?.data === 'success') {
        setToast({ open: true, message: footageVideoUploadData?.message, type: 'success' });
      }
      else {
        setToast({ open: true, message: footageVideoUploadData?.message, type: 'error' });
      }
    }
  }, [footageVideoUploadData])

  useEffect(() => {
    if (footageVideoUploadError) {
      setToast({ open: true, message: footageVideoUploadError, type: 'success' })
    }
  }, [footageVideoUploadError])

  useEffect(() => {
    if (footageVideoDownloadError) {
      setToast({ open: true, message: footageVideoDownloadError, type: 'success' })
    }
  }, [footageVideoDownloadError])

  useEffect(() => {
    const downloadFile = async () => {
      if (footageVideoDownloadData?.data) {
        try {
          const response = await fetch(footageVideoDownloadData.data);
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          console.log(blobUrl, 'dkncdknckdnck');
          link.href = blobUrl;
          const startTime = currentVideoData?.startTime || ''; // get startTime from video data

          // Convert "2025-05-27:15:58:37" to a proper Date object
          const [datePart, timePart] = startTime.split(':');
          const date = new Date(startTime.replace(':', ' ')); // or new Date(`${datePart} ${timePart}`)

          const day = String(date.getDate()).padStart(2, '0');
          const month = date.toLocaleString('default', { month: 'short' }).toLowerCase(); // 'may'
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          link.download = `${deviceId}_${day}_${month}_${year}_${hours}_${minutes}_${seconds}_${cameraId}.mp4`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(blobUrl);

          setToast({ open: true, message: 'Download started successfully', type: 'success' });
        } catch (err) {
          setToast({ open: true, message: 'Failed to download video', type: 'error' });
        }
      } else if (footageVideoDownloadData) {
        setToast({ open: true, message: footageVideoDownloadData?.message, type: 'error' });
      }
    };
    downloadFile();
  }, [footageVideoDownloadData]);

  function generateAlertData(requestData: RequestData): AlertData {
    // Note: adding a space between date and time for Date constructor
    const startDateTime = new Date(`${requestData.startDate} ${requestData.startTime}:00`);
    const endDateTime = new Date(`${requestData.endDate} ${requestData.endTime}:00`);

    const intervalInSeconds = 30;
    const dataPoints: AlertItem[] = [];
    let currentTime = new Date(startDateTime);

    while (currentTime < endDateTime) {
      const startTime = new Date(currentTime);
      const endTime = new Date(currentTime.getTime() + intervalInSeconds * 1000);

      dataPoints.push({
        startTime: formatDateTime(startTime),
        endTime: formatDateTime(endTime),
        status: "UNAVAILABLE",
        // cameraType: requestData.cameraType,
      });

      currentTime = endTime;
    }

    return {
      data: {
        "01": dataPoints,
      },
    };
  }


  useEffect(() => {
    if (Object.keys(requestData).length > 0) {
      const alertData = generateAlertData(requestData);
      console.log(alertData, 'alertData', requestData);
    }
  }, [requestData])

  const data = useMemo(() => {
    if (requestData && requestData.hasOwnProperty('startDate')) {
      const alertData = generateAlertData(requestData);
      console.log(alertData, 'alertData nonuxx');
      return alertData;
    } else if (requestData && cameraId) {
      return {
        data: {
          "01": requestData[cameraId ? cameraId[1] : ''],
        },
      };
    }
    return { data: { "01": [] } }; // or undefined if you prefer
  }, [requestData, cameraId]);


  const handleVideoData = (data: any) => {
    console.log(data, 'data');
    setCurrentVideoData(data);

  }

  console.log('data nonuxx', data);


  console.log(currentVideoData, 'currentVideoData xx');


  const handleVideo = (status: string) => {
    console.log(currentVideoData, 'currentVideoData');
    if (status === 'AVAILABLE_LOADED') {
      fetchFootageVideoDownloadData({
        deviceId: deviceId,
        cameraId: cameraId[1],
        startTime: currentVideoData?.startTime,
        endTime: currentVideoData?.endTime,
      })
    }
    else {
      fetchFootageVideoUploadData({
        deviceId: deviceId,
        cameraId: cameraId[1],
        startTime: currentVideoData?.startTime,
        endTime: currentVideoData?.endTime,
      })
    }
  }

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
    onRefresh()
  };

  const networkPollRef = useRef<NodeJS.Timeout | null>(null);

  // const {
  //   data: vehicleCummunicationStrengthData,
  //   fetchData: fetchVehicleCummunicationStrengthData,
  // } = useAxios<{ data: string }>(
  //   `${API_ENDPOINTS.dashboard.NETWORKSTRENGTH}/${verhicleId}`,
  //   "GET"
  // );


  const getNetworkStyle = (strength: string) => {
    const normalized = strength?.trim().toLowerCase();
    switch (normalized) {
      case 'excellent':
        return { bgColor: 'rgba(39, 174, 96, 0.15)', textColor: '#219653' }; // Green
      case 'medium':
        return { bgColor: 'rgba(255, 193, 7, 0.15)', textColor: '#FFC107' }; // Yellow
      case 'low':
        return { bgColor: 'rgba(244, 67, 54, 0.15)', textColor: '#F44336' }; // Red
      default:
        return { bgColor: 'rgba(189, 189, 189, 0.15)', textColor: '#9E9E9E' }; // Grey
    }
  };


  // useEffect(() => {
  //   if (open && verhicleId) {
  //     fetchVehicleCummunicationStrengthData(); // initial fetch
  //     networkPollRef.current = setInterval(() => {
  //       fetchVehicleCummunicationStrengthData();
  //     }, 60000); // every 10 seconds
  //   }

  //   return () => {
  //     if (networkPollRef.current) {
  //       clearInterval(networkPollRef.current);
  //       networkPollRef.current = null;
  //     }
  //   };
  // }, [open, verhicleId]);

  const [networkStrength, setNetworkStrength] = useState<string>('NA');

  useEffect(() => {
    if (open && verhicleId) {
      const currentVehicleId = verhicleId;
      console.log('Current Vehicle ID:', currentVehicleId);

      if (!currentVehicleId) return;

      const socket = new SockJS(`${process.env.NX_PUBLIC_API_URL}/ws`);
      const stompClient = new Client({
        webSocketFactory: () => socket,
        onConnect: () => {
          console.log("WebSocket connected, subscribing to signals topic");
          stompClient.subscribe(`/topic/signals/${currentVehicleId}`, (message: { body: string }) => {
            try {
              const parsedMessage = JSON.parse(message.body);
              console.log("Received signal message:", parsedMessage);
              setNetworkStrength(parsedMessage.signalStrength || 'NA');
            } catch (error) {
              console.error("Error parsing WebSocket message:", error);
            }
          });
        },
        onStompError: (frame) => {
          console.error('WebSocket error:', frame);
        },
        onDisconnect: () => {
          console.log('WebSocket disconnected');
        }
      });

      stompClient.activate();

      return () => {
        console.log("🧹 Cleaning up WebSocket connection");
        stompClient.deactivate();
      };
    }
  }, [open, verhicleId]);

  const strength = networkStrength;
  const { bgColor, textColor } = getNetworkStyle(strength);


  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="requested-video-title"
        aria-describedby="requested-video-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '70vw',
            height: '80vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            outline: 'none',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography id="requested-video-title" variant="h6">
              Video Playback
            </Typography>
            <div className="flex gap-2">
              <div className="flex items-center gap-1">
                <Typography variant="caption" color="secondary">
                  Network
                </Typography>
                <Box
                  sx={{
                    backgroundColor: bgColor,
                    px: "8px",
                    py: "4px",
                    borderRadius: "8px",
                    display: "inline-block",
                  }}
                >
                  <Typography
                    variant="overline"
                    color={textColor}
                    fontWeight={400}
                  >
                    {strength}
                  </Typography>
                </Box>
              </div>
              <CustomIconButton
                text={currentVideoData?.status === 'AVAILABLE_LOADED' ? 'Download Video' : 'Upload Video'}
                icon={<img src={currentVideoData?.status === 'AVAILABLE_LOADED' ? download : upload} alt="refresh" />}
                background="transparent"
                variant="outlined"
                onClick={() => { handleVideo(currentVideoData?.status) }}
              />
              <CustomIconButton
                text="Refresh"
                icon={<img src={refresh} alt="refresh" />}
                background="transparent"
                variant="outlined"
                onClick={handleRefresh}
              />
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </Box>

          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <PlayBackPlayer
              key={refreshKey}
              deviceId={deviceId}
              cameraId={cameraId}
              alertData={data}
              handleCurrentVideoData={(data) => {
                setCurrentVideoData(data);
                setCooldown(true);
                setCooldownTime(30);
              }}
            />
          </Box>
        </Box>
      </Modal>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any} />
    </>
  );
}
